import axios from 'axios';
import Vue from 'vue';
import store from '@/store';
const vue = new Vue(); // 创建axios实例
var instance = axios.create();
// 设置beseURL
instance.defaults.baseURL = '';
// 设置超时时间 50S
instance.defaults.timeout = 1000 * 50;
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/json';
// 发送前拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('ipp_token');
    if (token) config.headers['x-token'] = token;
    else {
      if (!config.url.includes('login')) store.dispatch('FedLogOut');
    }
    const lang = localStorage.getItem('ipp_lang');
    if (lang) config.headers['x-lang'] = lang;
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

function getMsgText(msg) {
  if (!msg) return '接口错误';
  if (msg === 'Auth Token Failed.') return '该账号异地登录，请重新登录';
  if (typeof msg === 'string') return msg;
  return '接口错误';
}

// 发送后拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    if (res.status === 200) {
      const token = localStorage.getItem('ipp_token');
      const { code, data, model, count, index } = res.data;
      if (code === 1000) {
        if (res.config.url.includes('/roi-index/save') && model && model.id) {
          return { data, resModel: model };
        } else if (res.config.url.includes('/roi/get-adjacent-roi')) {
          return { ...data, res_count: count, res_index: index };
        } else return data;
      } else if (token) {
        if (code === 1010) {
          store.dispatch('FedLogOut');
        } else {
          if (res.config.url.includes('/roi/get-adjacent-roi')) {
            return Promise.reject(res.data);
          }
          vue.$message.error(getMsgText(data));
          return Promise.reject(res.data);
        }
      } else {
        if (!res.config.url.includes('login')) {
          vue.$message.error(getMsgText(data));
        }

        return Promise.reject(res.data);
      }
    }
  },
  // 请求失败
  error => {
    vue.$message.error(error.response.data.msg);
    return Promise.reject(error);
  }
);

export default instance;
